import { useTheme, Box, Dialog, Button } from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import { useRef, useState } from 'react';
import VarList from '../editor/presetEditor/VarList';
import { useTranslation } from 'react-i18next';
import ExoDialog from '../exo/ExoDialog';
import { ExoRichTextEditor } from '../exo/ExoRichTextEditor';
import { Delta } from 'quill';

const PopUpTextEditor = ({
  startHTML,
  onSave,
  open,
  onClose,
  descriptionVars,
  showVars,
  imageType,
  imageApiFilter,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const [text, setText] = useState('');
  const richTextEditorRef = useRef(null);

  function prepereSave() {
    onSave(text);
    onClose();
  }

  const handleRTEClickVar = (text) => {
    // 1. Insert styled text
    const styledDelta = new Delta().insert(text, {
      size: '12px',
      font: 'montserrat',
    });
    // 2. Insert a single space with only size 12px formatting
    const resetDelta = new Delta().insert(' ', {
      size: '12px',
      font: 'montserrat',
    });

    // 3. Combine and apply
    richTextEditorRef.current.insertDelta(styledDelta.concat(resetDelta));
  };

  return (
    <ExoDialog open={open} onClose={onClose} limitWidth={!showVars}>
      <Box className="flex flex-col gap-2 overflow-hidden p-4 w-full h-full">
        <Box className="w-full h-full flex flex-row gap-2 overflow-hidden">
          {showVars && (
            <VarList
              dataCollection={descriptionVars}
              onVarClick={handleRTEClickVar}
            />
          )}
          <ExoRichTextEditor
            onHtmlChange={setText}
            startHtml={startHTML}
            ref={richTextEditorRef}
          />
        </Box>
        <Box
          sx={{ height: '50px' }}
          className="flex flex-row justify-between items-center px-2 w-full"
        >
          <Button onClick={onClose} variant="outlined" color="error">
            {t('Cancel')}
          </Button>
          <Button onClick={prepereSave} variant="contained" color="success">
            {t('Save')}
          </Button>
        </Box>
      </Box>
    </ExoDialog>
  );
};

export default PopUpTextEditor;
